import { render, staticRenderFns } from "./HistoryChart.vue?vue&type=template&id=cf9dd6d4&scoped=true"
import script from "./HistoryChart.vue?vue&type=script&lang=js"
export * from "./HistoryChart.vue?vue&type=script&lang=js"
import style0 from "./HistoryChart.vue?vue&type=style&index=0&id=cf9dd6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9dd6d4",
  null
  
)

export default component.exports